import {
    Backdrop,
    CircularProgress,
    Container,
    Grid,
    Box,
    Typography,
    TextField,
    Button,
    Select as MuiSelect,
    MenuItem,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    Divider,
    useTheme
} from '@mui/material';
import UserContext from "Context/UserProvider";
import { reservationOptions } from "components/charging/BusinessChargingNetworkParameters/reservationOptions";
import ModalComponent from "components/common/Modal/Modal";
import { useContext, useEffect, useRef, useState } from "react";
import toast from 'react-hot-toast';
import { IoMdClose } from "react-icons/io";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import {
    hasSharedInfrastructure
} from "utils/categoryUtils";
import WeeklyChargingReservation from "../../components/charging/BusinessChargingNetworkParameters/WeeklyChargerReservation";
import { fromHourValues } from "../../components/charging/BusinessChargingNetworkParameters/fromHourValues";
import { toHourValues } from "../../components/charging/BusinessChargingNetworkParameters/toHourValues";
import { weekDays as initialWeekDays, WeekDay } from "../../components/charging/BusinessChargingNetworkParameters/weekDays";
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DashboardCard from "components/dashboard/common/DashboardCard";
import { useApiService } from "../../services/ApiService/ApiService";

function BusinessChargingNetworkParametersPage(props: any) {

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const { userInfo, setUserInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [parameter, setParameter] = useState({}) as any;
    const location = useLocation();
    const params = location.state as any;
    const currentInput = useRef() as any;
    const [isDisabled, setIsDisabled] = useState(false);
    const [partnerChargingNetworkSubscription, setPartnerChargingNetworkSubscription] = useState(false);
    const [fromHour, setFromHour] = useState({ label: "00", value: 0, name: "fromHour" }) as any;
    const [toHour, setToHour] = useState({ label: "00", value: 0, name: "toHour" }) as any;
    const [subscribedValue, setSubscribedValue] = useState({ label: "No", value: false, name: "subscribed" }) as any;
    const subscribtion = [
        { label: "Yes", value: true, name: "subscribed" },
        { label: "No", value: false, name: "subscribed" },
    ];

    const [frequencyOptions, setFrequencyOptions] = useState({ label: "None", value: "NONE", name: "frequencyField" }) as any;
    const [frequencyValue, setFrequencyValue] = useState({}) as any;

    const [businessCategoryOptions, setBusinessCategoryOptions] = useState({ label: "None", value: "NONE", name: "businessCategoryField" }) as any;
    const [businessCategoryValue, setBusinessCategoryValue] = useState({}) as any;


    const [reservation, setReservation] = useState({ label: "Default", value: "DEFAULT", name: "reservationOptionField" }) as any;
    const [weekDays, setWeekDays] = useState(initialWeekDays);

    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [modalIsOpen, setIsOpen] = useState(false);

    const theme = useTheme();

    // Add CSS to hide spinner arrows
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            input[type="number"] {
                -moz-appearance: textfield;
            }
        `;
        document.head.appendChild(style);

        return () => {
            if (document.head.contains(style)) {
                document.head.removeChild(style);
            }
        };
    }, []);

    function closeModal() {
        setIsOpen(false);
    }


    const handleTimeChange = (dayIndex: any, field: any, value: any) => {
        setWeekDays(prevDays =>
            prevDays.map((day, index) =>
                index === dayIndex
                    ? { ...day, [field]: value }
                    : day
            )
        );
    };

    useEffect(() => {
        fetchBusiness();
    }, []);

    function onChange(e: any) {

        if (e.name === "fromHour") {
            setFromHour(fromHourValues.filter((i: any) => i.value === e.value)[0]);
        } else if (e.name === "toHour") {
            setToHour(toHourValues.filter((i: any) => i.value === e.value)[0]);
        } else if (e.name === "subscribed") {
            setSubscribedValue(subscribtion.filter((i: any) => i.value === e.value)[0]);
        } else if (e.name === "reservationOptionField") {
            setReservation(reservationOptions.filter((i: any) => i.value === e.value)[0]);
        } else if (e.name === "frequency") {


            const selectedFrequency = frequencyOptions.find((i: any) => i === e);

            if (selectedFrequency != null) {
                // Ensure the object structure is the same as in 'siteAccessPolicyOptions'
                const selectedValue = {
                    label: selectedFrequency, // assuming it has a 'name' field for the label
                    value: selectedFrequency, // the unique identifier, used as value
                    ...selectedFrequency, // spread the rest of the object properties if there are any others
                };
                setFrequencyValue(selectedValue);

            }

        } else if (e.name === "businessCategory") {

            const selectedBusinessCategory = businessCategoryOptions.find((i: any) => i === e);

            if (selectedBusinessCategory != null) {
                // Ensure the object structure is the same as in 'siteAccessPolicyOptions'
                const selectedValue = {
                    label: selectedBusinessCategory.name, // assuming it has a 'name' field for the label
                    value: selectedBusinessCategory.name, // the unique identifier, used as value
                    ...selectedBusinessCategory, // spread the rest of the object properties if there are any others
                };
                setBusinessCategoryValue(selectedValue);

            }


        } else if (e.target) {
            // Handle regular input fields like the cost inputs
            const { name, value } = e.target;
            setParameter((prev: any) => ({
                ...prev,
                [name]: value
            }));
        }
    }

    async function fetchBusiness() {
        try {
            const response = await fetchWithAuth('/business/get', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    accountUuid: userInfo.accountUuid,
                    businessUuid: userInfo.businessUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch business data');
            }

            const res_json = await response.json();
            setParameter(res_json.business);

            console.log("business", JSON.stringify(res_json.business));

            setFromHour(fromHourValues.filter((i: any) => i.value === res_json.business.chargersReservedFromHour)[0]);
            setToHour(toHourValues.filter((i: any) => i.value === res_json.business.chargersReservedToHour)[0]);
            setSubscribedValue(subscribtion.filter((i: any) => i.value === res_json.business.partnerChargingNetworkSubscription)[0]);
            setReservation(reservationOptions.filter((i: any) => i.value === res_json.business.reservationOption)[0]);
            setWeekDays(res_json.business.dayOfWeekReservation);

            setFrequencyOptions(res_json.business.frequencies.map((e: any) => ({ ...e, label: e, value: e, name: "frequency" })));
            setBusinessCategoryOptions(res_json.business.businessCategories.map((e: any) => ({ ...e, label: e.name, value: e.name, name: "businessCategory" })));

            const selectedFrequency = res_json.business.frequencies.find((i: any) => i === res_json.business.selectedFrequency);

            if (selectedFrequency != null) {
                // Ensure the object structure is the same as in 'siteAccessPolicyOptions'
                const selectedValue = {
                    label: selectedFrequency, // assuming it has a 'name' field for the label
                    value: selectedFrequency, // the unique identifier, used as value
                    ...selectedFrequency, // spread the rest of the object properties if there are any others
                };
                setFrequencyValue(selectedValue);

            } else {
                const selectedValue = {
                    label: "", // assuming it has a 'name' field for the label
                    value: "", // the unique identifier, used as value
                };
                setFrequencyValue(selectedValue);
            }

            setPartnerChargingNetworkSubscription(res_json.business.partnerChargingNetworkSubscription);

            const selectedBusinessCategory = res_json.business.businessCategories.find((i: any) => i.name === res_json.business.chargingCategory);

            if (selectedBusinessCategory != null) {
                // Ensure the object structure is the same as in 'siteAccessPolicyOptions'
                const selectedValue = {
                    label: selectedBusinessCategory.name, // assuming it has a 'name' field for the label
                    value: selectedBusinessCategory.name, // the unique identifier, used as value
                    ...selectedBusinessCategory, // spread the rest of the object properties if there are any others
                };
                setBusinessCategoryValue(selectedValue);

            } else {
                const selectedValue = {
                    label: "", // assuming it has a 'name' field for the label
                    value: "", // the unique identifier, used as value
                };
                setBusinessCategoryValue(selectedValue);
            }

        } catch (error) {
            console.error('Error fetching business data:', error);
            toast.error('Failed to fetch business data');
        } finally {
            setLoading(false);
        }
    }

    async function updateBusiness() {
        setIsDisabled(true);
        setSaving(true);
        try {
            const business = {
                uuid: params?.businessUuid || userInfo.businessUuid,
                chargersReservedFromHour: fromHour?.value || "00",
                chargersReservedToHour: toHour?.value || "00",
                partnerChargingNetworkSubscription: subscribedValue.value,
                selectedFrequency: frequencyValue.value || null,
                selectedBusinessCategory: businessCategoryValue.value,
                reservationOption: reservation.value,
                dayOfWeekReservation: weekDays,
                energyCostAcSinglePhaseGbpPerKWhOffPeak: Number(parameter.energyCostAcSinglePhaseGbpPerKWhOffPeak),
                energyCostAcThreePhaseGbpPerKWhOffPeak: Number(parameter.energyCostAcThreePhaseGbpPerKWhOffPeak),
                energyCostDcGbpPerKWhOffPeak: Number(parameter.energyCostDcGbpPerKWhOffPeak),
                energyCostAcSinglePhaseGbpPerKWhPeak: Number(parameter.energyCostAcSinglePhaseGbpPerKWhPeak),
                energyCostAcThreePhaseGbpPerKWhPeak: Number(parameter.energyCostAcThreePhaseGbpPerKWhPeak),
                energyCostDcGbpPerKWhPeak: Number(parameter.energyCostDcGbpPerKWhPeak)
            };

            const response = await fetchWithAuth('/business/update', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    accountUuid: userInfo.accountUuid,
                    business
                })
            });

            const res_json = await response.json();

            if (response.ok) {
                setUserInfo((prev: any) => ({
                    ...prev,
                    businessCategory: res_json.business.chargingCategory,
                }));

                toast.success('Configuration Updated Successfully', {
                    position: 'bottom-center',
                    duration: 5000,
                });
            } else {
                handleErrorResponse(res_json);
            }
        } catch (error) {
            console.error('Error updating business:', error);
            toast.error('Failed to update business configuration');
        } finally {
            setSaving(false);
            setIsDisabled(false);
        }
    }

    function handleErrorResponse(res_json: any) {
        let errorMsg = "An error occurred whilst saving this business.";

        switch (res_json.code) {
            case "BUSINESS_NO_RATE_CARDS":
                errorMsg = "No rate cards have been setup for this business.";
                break;
            case "BUSINESS_NO_DEFAULT_RATE_CARD":
                errorMsg = "No default rate card has been selected for this business";
                break;
            case "BUSINESS_NO_SITE_ACCESS_POLICIES":
                errorMsg = "No site access policies have been setup for this business.";
                break;
            case "ELECTRIC_VEHICLES_EXIST_FOR_BUSINESS":
                errorMsg = "Cannot change category as business has electric vehicles";
                break;
            case "SITE_RESTRICTION_APPLIES":
                errorMsg = "Site Access Restriction applied, but none selected";
                break;
            case "BUSINESS_NO_SHARED_INFRA_NO_SAP_RESTRICTION_NEEDED":
                errorMsg = "Business has no shared infrastructure, site access policy restriction cannot be set.";
                break;
            default:
                errorMsg = `An error (${res_json.code}) occurred whilst saving this business.`;
                break;
        }

        setErrorMessage(errorMsg);
        setIsError(true);
    }

    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage, {
                position: 'bottom-center',
                duration: 5000,
            });
        }
        setErrorMessage(null);

    }, [errorMessage]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Backdrop open={saving} sx={{ zIndex: 1300 }}>
                <CircularProgress />
            </Backdrop>

            <ModalComponent modalIsOpen={[modalIsOpen, setIsOpen]}>
                <Box sx={{ p: 3 }}>
                    <Box display="flex" justifyContent="flex-end">
                        <IoMdClose size={30} style={{ cursor: 'pointer' }} onClick={closeModal} />
                    </Box>
                    <Box sx={{ textAlign: 'center', my: 3 }}>
                        {isError && (
                            <Typography variant="h6" color="error">
                                {errorMessage}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </ModalComponent>

            <Container maxWidth="xl">
                <Box sx={{ pr: 3 }}>
                    {/* Rate Cards Banner */}
                    {(!parameter.rateCards || parameter.rateCards.length === 0) && (businessCategoryValue.value === "SHARE" || businessCategoryValue.value === "SHARE_AND_CHARGE") && subscribedValue.value === false && (
                        <Box sx={{
                            mb: 3,
                            p: 2,
                            bgcolor: 'warning.light',
                            color: 'warning.contrastText',
                            borderRadius: 1,
                            border: 1,
                            borderColor: 'warning.main'
                        }}>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                ⚠️ Rate Cards must be added before joining the charging network
                            </Typography>
                        </Box>
                    )}

                    <Grid container spacing={3}>
                        {/* Network Subscription Card */}
                        <Grid item xs={12} md={6}>
                            <DashboardCard
                                title="Network Subscription"
                                icon={<ElectricCarIcon />}
                                accentColor="primary"
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Subscribe To Charging Network</InputLabel>
                                        <MuiSelect
                                            value={subscribedValue.value ? "true" : "false"}
                                            name="subscribed"
                                            onChange={(e) => onChange({ name: 'subscribed', value: e.target.value === "true" })}
                                            disabled={partnerChargingNetworkSubscription}
                                            label="Subscribe To Charging Network"
                                        >
                                            {subscribtion.map((option) => (
                                                <MenuItem key={option.label} value={option.value ? "true" : "false"}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </MuiSelect>
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <InputLabel>Business Category</InputLabel>
                                        <MuiSelect
                                            value={businessCategoryValue.value}
                                            name="businessCategory"
                                            onChange={(e) => onChange({ name: 'businessCategory', value: e.target.value })}
                                            label="Business Category"
                                            disabled={true}
                                        >
                                            <MenuItem value={businessCategoryValue.value}>
                                                {businessCategoryValue.label}
                                            </MenuItem>
                                        </MuiSelect>
                                    </FormControl>
                                </Box>
                            </DashboardCard>
                        </Grid>

                        {/* Charger Reservation Settings */}
                        {hasSharedInfrastructure(businessCategoryValue.value) && (
                            <Grid item xs={12} md={6}>
                                <DashboardCard
                                    title="Charger Reservation"
                                    icon={<AccessTimeIcon />}
                                    accentColor="secondary"
                                >
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                        <FormControl fullWidth>
                                            <InputLabel>Reservation Option</InputLabel>
                                            <MuiSelect
                                                value={reservation.value}
                                                name="reservationOptionField"
                                                onChange={(e) => onChange({ name: 'reservationOptionField', value: e.target.value })}
                                                label="Reservation Option"
                                            >
                                                {reservationOptions.map((option) => (
                                                    <MenuItem key={option.label} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </MuiSelect>
                                        </FormControl>

                                        {reservation.value === "DEFAULT" ? (
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Reserved From Hour</InputLabel>
                                                    <MuiSelect
                                                        value={fromHour.value}
                                                        name="fromHour"
                                                        onChange={(e) => onChange({ name: 'fromHour', value: e.target.value })}
                                                        label="Reserved From Hour"
                                                    >
                                                        {fromHourValues.map((option) => (
                                                            <MenuItem key={option.label} value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </MuiSelect>
                                                </FormControl>

                                                <FormControl fullWidth>
                                                    <InputLabel>Reserved To Hour</InputLabel>
                                                    <MuiSelect
                                                        value={toHour.value}
                                                        name="toHour"
                                                        onChange={(e) => onChange({ name: 'toHour', value: e.target.value })}
                                                        label="Reserved To Hour"
                                                    >
                                                        {toHourValues.map((option) => (
                                                            <MenuItem key={option.label} value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </MuiSelect>
                                                </FormControl>
                                            </Box>
                                        ) : (
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                {/* Copy to All Days Button */}
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                    <Typography variant="subtitle2" color="text.secondary">
                                                        Set individual time restrictions for each day
                                                    </Typography>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => {
                                                            const firstDay = weekDays[0];
                                                            const updatedWeekDays = weekDays.map(day => ({
                                                                ...day,
                                                                fromHour: firstDay.fromHour,
                                                                toHour: firstDay.toHour
                                                            }));
                                                            setWeekDays(updatedWeekDays);
                                                            toast.success('Time settings copied to all days');
                                                        }}
                                                    >
                                                        Copy to All Days
                                                    </Button>
                                                </Box>

                                                {/* Days Grid */}
                                                <Box sx={{
                                                    display: 'grid',
                                                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                                    gap: 2
                                                }}>
                                                    {weekDays.map((dayInfo: WeekDay) => (
                                                        <WeeklyChargingReservation
                                                            key={dayInfo.dayIndex}
                                                            dayOfWeekLabel={dayInfo.day}
                                                            dayInfo={dayInfo}
                                                            onTimeChange={handleTimeChange}
                                                            readOnly={false}
                                                        />
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                </DashboardCard>
                            </Grid>
                        )}

                        {/* Energy Cost Cards */}
                        {hasSharedInfrastructure(businessCategoryValue.value) && (
                            <>
                                {/* Off-Peak Energy Costs */}
                                <Grid item xs={12} md={6}>
                                    <DashboardCard
                                        title="Off-Peak Energy Cost"
                                        icon={<AttachMoneyIcon />}
                                        accentColor="info"
                                    >
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                            <FormControl fullWidth>
                                                <InputLabel>AC Single Phase</InputLabel>
                                                <OutlinedInput
                                                    type="number"
                                                    value={parameter.energyCostAcSinglePhaseGbpPerKWhOffPeak || ''}
                                                    name="energyCostAcSinglePhaseGbpPerKWhOffPeak"
                                                    onChange={onChange}
                                                    startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                                    label="AC Single Phase"
                                                />
                                            </FormControl>

                                            <FormControl fullWidth>
                                                <InputLabel>AC Three Phase</InputLabel>
                                                <OutlinedInput
                                                    type="number"
                                                    value={parameter.energyCostAcThreePhaseGbpPerKWhOffPeak || ''}
                                                    name="energyCostAcThreePhaseGbpPerKWhOffPeak"
                                                    onChange={onChange}
                                                    startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                                    label="AC Three Phase"
                                                />
                                            </FormControl>

                                            <FormControl fullWidth>
                                                <InputLabel>DC</InputLabel>
                                                <OutlinedInput
                                                    type="number"
                                                    value={parameter.energyCostDcGbpPerKWhOffPeak || ''}
                                                    name="energyCostDcGbpPerKWhOffPeak"
                                                    onChange={onChange}
                                                    startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                                    label="DC"
                                                />
                                            </FormControl>
                                        </Box>
                                    </DashboardCard>
                                </Grid>

                                {/* Peak Energy Costs */}
                                <Grid item xs={12} md={6}>
                                    <DashboardCard
                                        title="Peak Energy Cost"
                                        icon={<AttachMoneyIcon />}
                                        accentColor="warning"
                                    >
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                            <FormControl fullWidth>
                                                <InputLabel>AC Single Phase</InputLabel>
                                                <OutlinedInput
                                                    type="number"
                                                    value={parameter.energyCostAcSinglePhaseGbpPerKWhPeak || ''}
                                                    name="energyCostAcSinglePhaseGbpPerKWhPeak"
                                                    onChange={onChange}
                                                    startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                                    label="AC Single Phase"
                                                />
                                            </FormControl>

                                            <FormControl fullWidth>
                                                <InputLabel>AC Three Phase</InputLabel>
                                                <OutlinedInput
                                                    type="number"
                                                    value={parameter.energyCostAcThreePhaseGbpPerKWhPeak || ''}
                                                    name="energyCostAcThreePhaseGbpPerKWhPeak"
                                                    onChange={onChange}
                                                    startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                                    label="AC Three Phase"
                                                />
                                            </FormControl>

                                            <FormControl fullWidth>
                                                <InputLabel>DC</InputLabel>
                                                <OutlinedInput
                                                    type="number"
                                                    value={parameter.energyCostDcGbpPerKWhPeak || ''}
                                                    name="energyCostDcGbpPerKWhPeak"
                                                    onChange={onChange}
                                                    startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                                    label="DC"
                                                />
                                            </FormControl>
                                        </Box>
                                    </DashboardCard>
                                </Grid>
                            </>
                        )}

                        {/* Save Button */}
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="center" mt={2}>
                                <Button
                                    variant="contained"
                                    startIcon={<SaveIcon />}
                                    onClick={updateBusiness}
                                    disabled={isDisabled}
                                    size="large"
                                >
                                    Save Changes
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
}

export default BusinessChargingNetworkParametersPage;
